// Anuva search history: each visitor's searches are kept in their own browser (localStorage)
// and offered back as suggestions with a clock icon, like a browser's address bar.
const KEY = 'anuva_search_history';
const MAX = 12;
const SHOWN = 8;
const root = window.Shopify?.routes?.root || '/';

const read = () => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list.filter((t) => typeof t === 'string') : [];
  } catch (e) {
    return [];
  }
};

const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch (e) {}
};

const normalize = (term) => (term || '').replace(/\s+/g, ' ').trim();

const save = (raw) => {
  const term = normalize(raw);
  if (term.length < 2 || term.startsWith('id:')) return;
  write([term, ...read().filter((t) => t.toLowerCase() !== term.toLowerCase())]);
};

const remove = (term) => write(read().filter((t) => t.toLowerCase() !== term.toLowerCase()));

const icon = (name) =>
  `<span class="anuva-sh__icon" style="--anuva-sh-icon:url('https://cdn.jsdelivr.net/npm/lucide-static@0.460.0/icons/${name}.svg')" aria-hidden="true"></span>`;

const escapeHtml = (text) => text.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

// Bold the part of the term that matches what is typed
const highlight = (term, query) => {
  const i = query ? term.toLowerCase().indexOf(query.toLowerCase()) : -1;
  if (i < 0) return escapeHtml(term);
  return `${escapeHtml(term.slice(0, i))}<strong>${escapeHtml(term.slice(i, i + query.length))}</strong>${escapeHtml(term.slice(i + query.length))}`;
};

const render = () => {
  document.querySelectorAll('[data-anuva-search-history]').forEach((aside) => {
    const input = aside.closest('form')?.querySelector('input[name="q"]');
    const query = normalize(input?.value);
    const all = read();
    const items = (query ? all.filter((t) => t.toLowerCase().includes(query.toLowerCase())) : all).slice(0, SHOWN);
    const list = aside.querySelector('[data-anuva-history-list]');
    const title = aside.querySelector('[data-anuva-history-title]');
    if (title) title.textContent = query ? 'From your history' : 'Recent searches';
    aside.querySelector('[data-anuva-history-clear]').hidden = Boolean(query);
    list.innerHTML = items
      .map(
        (term) => `<li class="anuva-sh__row">
          <a class="anuva-sh__item" href="${root}search?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last" data-anuva-history-term="${escapeHtml(term)}">
            ${icon('history')}<span class="anuva-sh__term">${highlight(term, query)}</span>
          </a>
          <button type="button" class="anuva-sh__remove button-unstyled" data-anuva-history-remove="${escapeHtml(term)}" aria-label="Remove ${escapeHtml(term)} from history">${icon('x')}</button>
        </li>`
      )
      .join('');
    aside.hidden = items.length === 0;
    aside.closest('.predictive-search-form__content-wrapper')?.classList.toggle('has-history', items.length > 0);
  });
};

if (!window.__anuvaSearchHistory) {
  window.__anuvaSearchHistory = true;

  // A search submitted from any search form (modal, search page, header input)
  document.addEventListener(
    'submit',
    (event) => {
      const q = event.target.querySelector?.('input[name="q"]');
      if (q && (event.target.action || '').includes('/search')) save(q.value);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const t = event.target;
      const removeBtn = t.closest('[data-anuva-history-remove]');
      if (removeBtn) {
        event.preventDefault();
        event.stopPropagation();
        remove(removeBtn.dataset.anuvaHistoryRemove);
        render();
        return;
      }
      if (t.closest('[data-anuva-history-clear]')) {
        event.preventDefault();
        write([]);
        render();
        return;
      }
      if (t.closest('.predictive-search__reset-button')) setTimeout(render, 50);
      const historyItem = t.closest('[data-anuva-history-term]');
      if (historyItem) return save(historyItem.dataset.anuvaHistoryTerm);
      // Picking a suggestion, or opening a result, counts as searching the typed term
      const pill = t.closest('.predictive-search-results__pill');
      if (pill) return save(pill.getAttribute('aria-label') || pill.textContent);
      const result = t.closest('.predictive-search-form__content a[href]');
      if (result) {
        const q = result.closest('form')?.querySelector('input[name="q"]');
        if (q) save(q.value);
      }
    },
    true
  );

  // Enter on the "View all" button or in the input submits the form; the submit listener saves it.
  document.addEventListener('input', (event) => {
    if (event.target.matches?.('.predictive-search-form input[name="q"]')) render();
  });
  document.addEventListener('focusin', (event) => {
    if (event.target.matches?.('.predictive-search-form input[name="q"]')) render();
  });

  // Landing on the search results page counts too (e.g. a search from another page or a shared link)
  if (location.pathname.replace(root, '/').startsWith('/search')) {
    const q = new URLSearchParams(location.search).get('q');
    if (q) save(q);
  }

  render();
}
